import styled, { keyframes } from 'styled-components';

export const UploadDocumentsWrapper = styled.div`
  width: 100%;
  min-height: calc(100vh - 64px);
  background: ${({ theme }) => theme.landing.background};
  transition: background 0.3s ease;
`;

export const UploadDocumentsContainer = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  margin-top: 64px;
  padding: ${({ theme }) => theme.landingSpacing.xl};

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.lg}) {
    padding: ${({ theme }) => theme.landingSpacing.lg};
  }

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.md}) {
    padding: ${({ theme }) => theme.landingSpacing.md};
  }

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    padding: ${({ theme }) => theme.landingSpacing.md};
  }
`;

export const HeaderSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${({ theme }) => theme.landingSpacing.xl};

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.md}) {
    flex-direction: column;
    align-items: flex-start;
    gap: ${({ theme }) => theme.landingSpacing.md};
  }

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const SectionTitle = styled.h1`
  font-weight: 500;
  font-size: 1.75rem;
  line-height: 1.2;
  margin: 0;
  color: ${({ theme }) => theme.landing.text};
  letter-spacing: -0.025em;

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.md}) {
    font-size: 1.75rem;
  }

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    font-size: 1.5rem;
  }
`;

export const SectionDescription = styled.p`
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5;
  color: ${({ theme }) => theme.landing.textSecondary};
  margin: 4px 0 0 0;
  padding: 0;

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    font-size: 0.95rem;
  }
`;

export const ActionButtons = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.landingSpacing.sm};

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.md}) {
    width: 100%;
  }

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    flex-direction: column;
    width: 100%;
  }
`;

export const DashboardButton = styled.button`
  background: transparent;
  color: ${({ theme }) => theme.landing.text};
  border: 1px solid ${({ theme }) => theme.landing.cardBorder};
  border-radius: ${({ theme }) => theme.landingBorderRadius.md};
  padding: ${({ theme }) => theme.landingSpacing.sm} ${({ theme }) => theme.landingSpacing.md};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${({ theme }) => theme.landing.iconBg};
    border-color: ${({ theme }) => theme.landing.text};
  }

  &:active {
    transform: scale(0.98);
  }

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.md}) {
    flex: 1;
    text-align: center;
  }

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    width: 100%;
    padding: ${({ theme }) => theme.landingSpacing.sm} ${({ theme }) => theme.landingSpacing.md};
    font-size: 0.95rem;
  }
`;

export const SaveButton = styled.button`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.landingSpacing.sm};
  background: ${({ theme }) => theme.landing.buttonBg};
  color: #fff;
  border: 1px solid ${({ theme }) => theme.landing.buttonBg};
  border-radius: ${({ theme }) => theme.landingBorderRadius.md};
  padding: ${({ theme }) => theme.landingSpacing.sm} ${({ theme }) => theme.landingSpacing.md};

  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${({ theme }) => theme.landing.buttonHover};
    box-shadow: 0px 8px 16px rgba(37, 99, 235, 0.2);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.md}) {
    flex: 1;
    justify-content: center;
  }

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    width: 100%;
    padding: ${({ theme }) => theme.landingSpacing.sm} ${({ theme }) => theme.landingSpacing.md};
    font-size: 0.95rem;
  }
`;

export const ContentGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${({ theme }) => theme.landingSpacing.lg};
  margin-bottom: ${({ theme }) => theme.landingSpacing.xl};

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.lg}) {
    gap: ${({ theme }) => theme.landingSpacing.md};
  }

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.md}) {
    grid-template-columns: 1fr;
    gap: ${({ theme }) => theme.landingSpacing.md};
  }
`;

export const DocumentDetailsSection = styled.div`
  background: ${({ theme }) => theme.landing.cardBg};
  border: 1px solid ${({ theme }) => theme.landing.cardBorder};
  border-radius: ${({ theme }) => theme.landingBorderRadius.lg};
  padding: ${({ theme }) => theme.landingSpacing.lg};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.landingSpacing.md};

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    padding: ${({ theme }) => theme.landingSpacing.md};
  }
`;

export const SectionLabel = styled.h2`
  font-weight: 600;
  font-size: 1rem;
  line-height: 1.4;
  color: ${({ theme }) => theme.landing.text};
  margin: 0 0 ${({ theme }) => theme.landingSpacing.md} 0;
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.landingSpacing.xs};
`;

export const InputLabel = styled.label`
  font-weight: 500;
  font-size: 0.9rem;
  line-height: 1.4;
  color: ${({ theme }) => theme.landing.textSecondary};
`;

export const TextInput = styled.input`
  background: ${({ theme }) => theme.landing.background};
  border: 1px solid ${({ theme }) => theme.landing.cardBorder};
  border-radius: ${({ theme }) => theme.landingBorderRadius.md};
  padding: ${({ theme }) => theme.landingSpacing.sm} ${({ theme }) => theme.landingSpacing.md};
  font-size: 0.95rem;
  line-height: 1.5;
  color: ${({ theme }) => theme.landing.text};
  width: 100%;
  box-sizing: border-box;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease;
  outline: none;

  &::placeholder {
    color: ${({ theme }) => theme.landing.textSecondary};
    opacity: 0.6;
  }

  &:focus {
    border-color: ${({ theme }) => theme.landing.buttonBg};
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
  }
`;

export const TextAreaInput = styled.textarea`
  background: ${({ theme }) => theme.landing.background};
  border: 1px solid ${({ theme }) => theme.landing.cardBorder};
  border-radius: ${({ theme }) => theme.landingBorderRadius.md};
  padding: ${({ theme }) => theme.landingSpacing.sm} ${({ theme }) => theme.landingSpacing.md};
  font-size: 0.95rem;
  line-height: 1.5;
  color: ${({ theme }) => theme.landing.text};
  width: 100%;
  box-sizing: border-box;
  resize: vertical;
  min-height: 120px;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease;
  outline: none;
  font-family: inherit;

  &::placeholder {
    color: ${({ theme }) => theme.landing.textSecondary};
    opacity: 0.6;
  }

  &:focus {
    border-color: ${({ theme }) => theme.landing.buttonBg};
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
  }
`;

export const CharacterCount = styled.span`
  font-size: 0.8rem;
  line-height: 1.4;
  color: ${({ theme }) => theme.landing.textSecondary};
  text-align: right;
  margin-top: 2px;
`;

export const UploadSection = styled.div`
  background: ${({ theme }) => theme.landing.cardBg};
  border: 1px solid ${({ theme }) => theme.landing.cardBorder};
  border-radius: ${({ theme }) => theme.landingBorderRadius.lg};
  padding: ${({ theme }) => theme.landingSpacing.lg};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.landingSpacing.md};

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    padding: ${({ theme }) => theme.landingSpacing.md};
  }
`;

export const UploadDropZone = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.landingSpacing.sm};
  border: 2px dashed ${({ theme }) => theme.landing.cardBorder};
  border-radius: ${({ theme }) => theme.landingBorderRadius.lg};
  padding: ${({ theme }) => theme.landingSpacing.xl};
  text-align: center;
  transition: all 0.2s ease;
  cursor: pointer;
  background: ${({ theme }) => theme.landing.background};

  span {
    font-size: 0.9rem;
    color: ${({ theme }) => theme.landing.textSecondary};
  }

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    padding: ${({ theme }) => theme.landingSpacing.lg};
  }
`;

export const UploadIcon = styled.div`
  width: 72px;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.landing.iconBg};
  border-radius: ${({ theme }) => theme.landingBorderRadius.lg};
  color: ${({ theme }) => theme.landing.buttonBg};
  margin-bottom: ${({ theme }) => theme.landingSpacing.xs};

  svg {
    width: 40px;
    height: 40px;
  }
`;

export const UploadText = styled.p`
  font-weight: 500;
  font-size: 1rem;
  line-height: 1.5;
  color: ${({ theme }) => theme.landing.text};
  margin: 0;
`;

export const BrowseButton = styled.button`
  background: transparent;
  color: ${({ theme }) => theme.landing.buttonBg};
  border: 1px solid ${({ theme }) => theme.landing.buttonBg};
  border-radius: ${({ theme }) => theme.landingBorderRadius.md};
  padding: ${({ theme }) => theme.landingSpacing.xs} ${({ theme }) => theme.landingSpacing.md};
  font-weight: 500;
  font-size: 0.9rem;
  line-height: 1.4;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${({ theme }) => theme.landing.buttonBg};
    color: ${({ theme }) => theme.landing.cardBg};
  }

  &:active {
    transform: scale(0.98);
  }
`;

export const SupportedFormats = styled.p`
  font-size: 0.8rem;
  line-height: 1.4;
  color: ${({ theme }) => theme.landing.textSecondary};
  margin: 0;
`;

export const AddDocumentButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.landingSpacing.sm};
  background: ${({ theme }) => theme.landing.buttonBg};
  color: #fff;
  border: 1px solid ${({ theme }) => theme.landing.buttonBg};
  border-radius: ${({ theme }) => theme.landingBorderRadius.md};
  padding: ${({ theme }) => theme.landingSpacing.sm} ${({ theme }) => theme.landingSpacing.md};
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;

  svg {
    width: 16px;
    height: 16px;
  }

  &:hover {
    background: ${({ theme }) => theme.landing.buttonHover};
    box-shadow: 0px 8px 16px rgba(37, 99, 235, 0.2);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const UploadedDocumentsSection = styled.div`
  background: ${({ theme }) => theme.landing.cardBg};
  border: 1px solid ${({ theme }) => theme.landing.cardBorder};
  border-radius: ${({ theme }) => theme.landingBorderRadius.lg};
  padding: ${({ theme }) => theme.landingSpacing.lg};

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    padding: ${({ theme }) => theme.landingSpacing.md};
  }
`;

export const DocumentsList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.landingSpacing.sm};
`;

export const DocumentItem = styled.li`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.landingSpacing.md};
  padding: ${({ theme }) => theme.landingSpacing.md};
  background: ${({ theme }) => theme.landing.background};
  border: 1px solid ${({ theme }) => theme.landing.cardBorder};
  border-radius: ${({ theme }) => theme.landingBorderRadius.md};
  transition: all 0.2s ease;

  &:hover {
    border-color: ${({ theme }) => theme.landing.buttonBg};
    box-shadow: 0px 4px 12px rgba(37, 99, 235, 0.08);
  }

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    flex-wrap: wrap;
    gap: ${({ theme }) => theme.landingSpacing.sm};
  }
`;

export const DocumentIconWrapper = styled.div`
  width: 40px;
  height: 40px;
  min-width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.landing.iconBg};
  border-radius: ${({ theme }) => theme.landingBorderRadius.md};
  color: ${({ theme }) => theme.landing.buttonBg};

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const DocumentInfo = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const DocumentName = styled.span`
  font-weight: 500;
  font-size: 0.95rem;
  line-height: 1.4;
  color: ${({ theme }) => theme.landing.text};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const DocumentMeta = styled.span`
  font-size: 0.8rem;
  line-height: 1.4;
  color: ${({ theme }) => theme.landing.textSecondary};
`;

export const DocumentActions = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.landingSpacing.sm};

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    margin-left: auto;
  }
`;

export const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  background: ${({ theme }) => theme.landing.iconBg};
  color: ${({ theme }) => theme.landing.text};
  border-radius: ${({ theme }) => theme.landingBorderRadius.md};
  padding: 2px ${({ theme }) => theme.landingSpacing.sm};
  font-weight: 600;
  font-size: 0.75rem;
  line-height: 1.6;
  letter-spacing: 0.04em;
  text-transform: uppercase;
`;

export const DeleteButton = styled.button`
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  border-radius: ${({ theme }) => theme.landingBorderRadius.md};
  color: ${({ theme }) => theme.landing.textSecondary};
  cursor: pointer;
  transition: all 0.2s ease;

  svg {
    width: 18px;
    height: 18px;
  }

  &:hover {
    background: rgba(239, 68, 68, 0.1);
    color: #ef4444;
  }

  &:active {
    transform: scale(0.95);
  }
`;

export const GlobalError = styled.div`
  background: var(--color-background-danger);
  border: 0.5px solid var(--color-border-danger);
  border-radius: var(--border-radius-md);
  padding: 10px 14px;
  font-size: 13px;
  color: var(--color-text-danger);
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ErrorText = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.landing.errorColor};
  margin-top: 2px;
`;
export const EmptyState = styled.div`
  padding: 2.5rem;
  text-align: center;
  color: var(--color-text-tertiary);
  font-size: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
`;
const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;
export const IconButton = styled.button`
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--border-radius-md);
  border: 0.5px solid var(--color-border-secondary);
  background: var(--color-background-primary);
  color: ${({ $variant }) =>
    $variant === 'delete' ? 'var(--color-text-danger)' : 'var(--color-text-secondary)'};
  cursor: pointer;
  transition:
    background 0.15s,
    color 0.15s;

  &:hover:not(:disabled) {
    background: ${({ $variant }) =>
      $variant === 'delete'
        ? 'var(--color-background-danger)'
        : 'var(--color-background-secondary)'};
    border-color: ${({ $variant }) =>
      $variant === 'delete' ? 'var(--color-border-danger)' : 'var(--color-border-primary)'};
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  .spin {
    animation: ${spin} 1s linear infinite;
  }
`;
